/*
 */
import { defineMessages } from 'react-intl';

const scope = 'app.workspace.sourceSettings';

export default defineMessages({
  sourceSettingsSource: {
    id: `${scope}.sourceSettingsSource`,
    defaultMessage: 'Source',
  },
  sourceSettingsNone: {
    id: `${scope}.sourceSettingsNone`,
    defaultMessage: 'None',
  },
  sourceSettingsAlfresco: {
    id: `${scope}.sourceSettingsAlfresco`,
    defaultMessage: 'Alfresco',
  },
  sourceSettingsSave: {
    id: `${scope}.sourceSettingsSave`,
    defaultMessage: 'Save',
  },
  sourceSettingsCancel: {
    id: `${scope}.sourceSettingsCancel`,
    defaultMessage: 'Cancel',
  },
  sourceSettingsSite: {
    id: `${scope}.sourceSettingsSite`,
    defaultMessage: 'Site',
  },
  sourceSettingsPlaceholder: {
    id: `${scope}.sourceSettingsPlaceholder`,
    defaultMessage: 'Enter site name...',
  },
  sourceSettingsSelectAccessError: {
    id: `${scope}.sourceSettingsSelectAccessError`,
    defaultMessage: 'Access error',
  },
  sourceSettingsSelectAlfrescoError: {
    id: `${scope}.sourceSettingsSelectAlfrescoError`,
    defaultMessage: 'Alfresco access error',
  },
});
